import styles from '../TaskForm.module.scss';

interface TpElemValueWrapperProps {
  elemName: string;
  children: React.ReactNode;
}

export const ElemValueWrapper = ({ elemName, children }: TpElemValueWrapperProps) => {
  return (
    <div className={styles.elemValueWrapper}>
      <div className={styles.elemValueName}>{elemName}</div>
      <div className={styles.elemValueContent}>{children}</div>
    </div>
  );
};
